<template>
  <div class="user-management-container">
    <el-form
      ref="form"
      class="form"
      :label-position="labelPosition"
      label-width="100px"
      :model="form"
      :rules="rules"
    >
      <!-- 选择终端 -->
      <el-form-item label="终端" prop="endpointId">
        <el-select
          v-model="form.endpointId"
          placeholder="请选择终端"
        >
          <el-option
            v-for="item in endpointList"
            :key="item.endpointId"
            :label="item.title"
            :value="item.endpointId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="页面地址" prop="path">
        <el-input v-model="form.path" placeholder="请输入页面地址"></el-input>
      </el-form-item>
      <el-form-item label="小程序码" v-if="qrCode">
        <img :src="qrCode" class="qrcode" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('form')">
          立即生成
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { findCode, findEndpointList } from '@/api/app'
import storejs from 'store'
export default {
  name: 'WechatQrCode',
  data() {
    return {
      labelPosition: 'right',
      form: {
        path: '',
        endpointId: '',
      },
      rules: {
        path: [{ required: true, trigger: 'blur', message: '请输入页面地址' }],
        endpointId: [
          { required: true, trigger: 'blur', message: '请选择终端' },
        ],
      },
      endpointList: [],
      qrCode: '',
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/display/wechatQrCode') {
        this.findEndpointList()
        this.endpointId=''
      }
    },
  },
  created() {
    this.findEndpointList()
  },
  methods: {
    //获取所有终端
    async findEndpointList() {
      const adppId = storejs.get('appId')
      const res = await findEndpointList({clientAppId:adppId,page:1,size:1000})
      if (!res) return
      this.endpointList = res.list
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const ret = await findCode({
            path: this.form.path,
            endpointId:this.form.endpointId
          })
          this.qrCode = ret.url
          console.log('ret', ret)
          this.$message.success('生成小程序码成功')
        } else {
          // this.$message.warning('生成小程序码失败')
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.form {
  width: 60%;
}
.qrcode {
  width: 200px;
  height: 200px;
  border: 1px solid #f3f3f3;
  border-radius: 10px;
}
</style>
